module.exports = __webpack_public_path__ + "img/IonGirnet.881fd3dd.png";